module.exports = __webpack_public_path__ + "img/block6-card5.0802f46b.svg";